import { useEffect, useState } from "react";
import styles from "./styles.module.css";
import { ReactComponent as BackArrowSvg } from "../../../../assets/backarrow.svg";
import { ReactComponent as XLSSvg } from "../../../../assets/XLS.svg";
import { ReactComponent as ExcelSvg } from "../../../../assets/excel.svg";
import { Button, Form, Label } from "semantic-ui-react";
import { Formik, ErrorMessage } from "formik";
import { InputTemp, SelectTemp } from "../../../../app/common/form/Custom";
import { vendorSchema } from "../../../../app/validation/validationSchema";
import MyTextArea from "../../../../app/common/form/MyTextArea";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormLabel,
  LinearProgress,
  Radio,
  RadioGroup,
  linearProgressClasses,
  styled,
} from "@mui/material";
import UploadImageTemp from "../../../../app/common/form/Custom/UploadImageTemp";
import Modal from "../../../../app/common/modals/Custom";
import { ReactComponent as ThumbsUpSvg } from "../../../../assets/navbericon/thumbsup.svg";
import { useNavigate } from "react-router-dom";
import { IFileDetails, ProductForm } from "../../../../app/models/product";
import { useStore } from "../../../../app/stores/store";
import Loading from "../../../../app/layout/Loading";
import { observer } from "mobx-react-lite";
import ProductBulkUploadInput from "../../../../app/common/form/Custom/Product/ProductBulkUploadInput";
// import {ExampleFile as File} from "../../../../assets/ProductExample.csv"
import { CSVLink } from "react-csv";
import responseCodes, {
  handleStateChange,
  handleStateChange2,
  handleStateDecimalToPrice
} from "../../../../app/common/hooks/helpers";
import { toast } from "react-toastify";

const BorderLinearProgress = styled(LinearProgress)(
  ({ theme, valueBuffer }) => ({
    height: 4,
    borderRadius: 5,
    width: `${valueBuffer}%`,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#32c36c" : "#308fe8",
    },
    // [`&.${linearProgressClasses.buffer}`]: {
    //   width: valueBuffer,
    // },
  })
);

const NewProduct = () => {
  const [modal, setModal] = useState("");
  const navigate = useNavigate();
  const [inputField] = useState<ProductForm>(new ProductForm());
  const [buklInputField, setBulkInputField] = useState<ProductForm[]>([]);
  const [fileDetailsList, setFileDetailsList] = useState<IFileDetails[]>([]);
  const [imageUpload, setImageUpload] = useState<string[]>([]);
  const [imageUploadTypes, setImageUploadTypes] = useState<string[]>([]);
  // const bulkUploadRef = useRef<HTMLInputElement>(null);
  const [excelFileError, setExcelFileError] = useState("");
  const [vat, setVat] = useState(false);
  const { productStore } = useStore();
  const {
    loadingInitial,
    getProductCategories,
    getProductBrands,
    categoryList,
    brandsList,
    inverterTypesList,
    addProduct,
    addMultipleProducts,
    loading,
    getUrl,
    getInverterTypes,
  } = productStore;
  const UPLOAD_LIMIT = Number(process.env.REACT_APP_UPLOAD_LIMIT);

  const imageHandler = (e: any, index?: number) => {
    try {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      if (file.size > UPLOAD_LIMIT) {
        toast.error('File too large. Maximum upload size is 1 MB.');
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.readyState === 2) {
          if (index !== undefined) {
            const newImageUpload = [...imageUpload];
            newImageUpload[index] = reader.result!.toString();
            setImageUpload(newImageUpload);
            // console.log("imageUploadTypes", newImageUpload);
          } else
            setImageUpload([
              ...imageUpload,
              reader.result!.toString(),
            ]);
          setImageUploadTypes([...imageUploadTypes, file.type]);
        }
      };
      reader.readAsDataURL(file);
    } catch {
      // console.log("none");
      // setImageUpload([]);
    }
  };
  const saveForm = async (values: any) => {
    var urlList: string[] = [];
    try {
      // for (let i = 0; i < imageUpload.length; i++) {
      //   const imagePayload = {
      //     postedFilebase64: imageUpload[i],
      //     documentName: `ProductImage${Math.floor(Math.random() * 6) + 1}`,
      //     filetype: imageUploadTypes[i],
      //   };
      //   await getUrl(imagePayload).then((data) => urlList.push(data.data));
      // }
      if (imageUpload.length > 0) {
        const request = {
          ...values,
          minIvtCap: String(values.minIvtCap),
          batType: String(values.batType),
          batTypeValue: String(values.batTypeValue),
          multipleProductImageUrl: imageUpload,
          productPrimaryImageUrl: imageUpload[0],
          productCurrentPrice: Number.parseFloat(
            String(values.productCurrentPrice)?.split(",")?.join("")
          ),
          productPreviousPrice: Number.parseFloat(
            String(values.productPreviousPrice)?.split(",")?.join("")
          ),
          productQuantity: Number.parseFloat(
            String(values.productQuantity)?.split(",")?.join("")
          ),
          weight: Number.parseFloat(
            String(values.weight)?.split(",")?.join("")
          ),
        };
        const { category, ...payload } = request;
        // console.log(payload);
        await addProduct(payload).then((res) => {
          if (res?.responseCode === responseCodes.response_00) {
            toast.info(res.responseMessage);
            setModal("success");
          }
        });
      }
    } catch (error) {
      toast.info(String(error));
      return error;
    }
  };
  const saveMultiForm = async () => {
    await addMultipleProducts(buklInputField).then((res) => {
      if (res?.responseCode === responseCodes.response_00) {
        toast.info(res.responseMessage);
        setModal("success");
      }
    });
  };

  const csvData = [
    [
      "Name",
      "Brand",
      "Price",
      "Category",
      "BatteryType(Inverters)",
      "BatteryTypeValue(Inverters)",
      "MinimumInverterCapacity(Inverters)",
      "Description",
      "Quantity",
      "Note",
      "Weight(KG)",
      "CarryOutDelivery",
      "ImageUrl1",
      "ImageUrl2",
      "ImageUrl3",
      "ImageUrl4",
      "ImageUrl5",
    ],
    [
      "Product 1",
      "Example 1",
      20000,
      "Category1",
      "12V 200A LA BATTERY QTY (min)",
      "1.5",
      "8000",
      "Description example 1",
      20,
      "Note example 1",
      500,
      "TRUE",
      "https://upload.wikimedia.org/wikipedia/en/6/66/Generac_Industrial_Diesel_Genset.jpg",
      "https://upload.wikimedia.org/wikipedia/en/6/66/Generac_Industrial_Diesel_Genset.jpg",
      "https://upload.wikimedia.org/wikipedia/en/6/66/Generac_Industrial_Diesel_Genset.jpg",
      "https://upload.wikimedia.org/wikipedia/en/6/66/Generac_Industrial_Diesel_Genset.jpg",
      "https://upload.wikimedia.org/wikipedia/en/6/66/Generac_Industrial_Diesel_Genset.jpg",
    ],
    [
      "Product 2",
      "Example 2",
      20000,
      "Category2",
      "12V 200A LA BATTERY QTY (min)",
      "2",
      "3000",
      "Description example 2",
      20,
      "Note example 2",
      500,
      "TRUE",
      "https://upload.wikimedia.org/wikipedia/en/6/66/Generac_Industrial_Diesel_Genset.jpg",
      "https://upload.wikimedia.org/wikipedia/en/6/66/Generac_Industrial_Diesel_Genset.jpg",
      "https://upload.wikimedia.org/wikipedia/en/6/66/Generac_Industrial_Diesel_Genset.jpg",
      "https://upload.wikimedia.org/wikipedia/en/6/66/Generac_Industrial_Diesel_Genset.jpg",
      "https://upload.wikimedia.org/wikipedia/en/6/66/Generac_Industrial_Diesel_Genset.jpg",
    ],
    [
      "Product 3",
      "Example 3",
      20000,
      "Category3",
      "12V 200A LA BATTERY QTY (min)",
      "1.3",
      "4000",
      "Description example 3",
      20,
      "Note example 3",
      500,
      "FALSE",
      "https://upload.wikimedia.org/wikipedia/en/6/66/Generac_Industrial_Diesel_Genset.jpg",
      "https://upload.wikimedia.org/wikipedia/en/6/66/Generac_Industrial_Diesel_Genset.jpg",
      "https://upload.wikimedia.org/wikipedia/en/6/66/Generac_Industrial_Diesel_Genset.jpg",
      "https://upload.wikimedia.org/wikipedia/en/6/66/Generac_Industrial_Diesel_Genset.jpg",
      "https://upload.wikimedia.org/wikipedia/en/6/66/Generac_Industrial_Diesel_Genset.jpg",
    ],
  ];

  const helperData = [["Category", "Brand", "BatteryType(Inverters)"]];
  if (brandsList && categoryList && inverterTypesList) {
    const largest = Math.max(
      brandsList.length,
      categoryList.length,
      inverterTypesList.length
    );
    for (let i = 0; i < largest; i++) {
      helperData.push([
        categoryList[i] ? categoryList[i].category : "",
        brandsList[i] ? brandsList[i].brandName : "",
        inverterTypesList[i] ? inverterTypesList[i].batteryInvtName : "",
      ]);
    }
  }

  const clearForm = () => {
    setFileDetailsList([]);
    setBulkInputField([]);
    setExcelFileError("");
  };

  const getUnits = (request: number) => {
    let response: { value: string; unit: string } = { value: "", unit: "" };
    if (request > 1024 && request < 1048576) {
      response = {
        value: Number.parseFloat(String(request / 1024))
          .toFixed(2)
          .toString(),
        unit: "kb",
      };
      return response;
    } else if (request > 1048576) {
      response = {
        value: Number.parseFloat(String(request / 1048576))
          .toFixed(2)
          .toString(),
        unit: "MB",
      };
      return response;
    } else {
      return { value: `${request}`, unit: "bytes" };
    }
  };

  useEffect(() => {
    getProductCategories().then(() =>
      getProductBrands().then(() => getInverterTypes())
    );
  }, [getProductBrands, getProductCategories, getInverterTypes]);
  // console.log(buklInputField);
  return (
    <div className={styles.page}>
      {(loadingInitial === "loading" || loading) && <Loading />}
      {modal === "success" && (
        <Modal
          variant="unstyled"
          style={{ position: "fixed", zIndex: "2" }}
          openModal={true}
          closeModal={() => setModal("")}
        >
          <div className={styles.verifyAccountModal}>
            {/* <h2>Activate Selling Permission</h2> */}

            <div className={styles.info}>
              {" "}
              <ThumbsUpSvg />
            </div>
            <div className={styles.welcomeText}>
              <p>
                Product{buklInputField.length > 1 && "s"} Added Successfully
              </p>
            </div>

            <div className={styles.twoButton}>
              <Button
                positive
                className={styles.modalactivate}
                onClick={() => navigate("/vendor/products")}
              >
                <div className={styles.button}>
                  <span>Okay!</span>
                </div>
              </Button>
            </div>
          </div>
        </Modal>
      )}
      {modal === "bulkupload" && (
        <Modal
          variant="unstyled"
          style={{ position: "fixed", zIndex: "2" }}
          openModal={true}
          closeModal={() => {
            clearForm();
            setModal("");
          }}
        >
          <div className={styles.uploadModal}>
            {/* <h2>Activate Selling Permission</h2> */}
            <h1>File Upload</h1>
            <div className={styles.info}>
              <div
                className={styles.uploadBox}
                // onClick={() =>
                //   bulkUploadRef.current && bulkUploadRef.current.click()
                // }
              >
                <ProductBulkUploadInput
                  // bulkRef={bulkUploadRef}
                  inputField={buklInputField}
                  setInputField={setBulkInputField}
                  setExcelFileError={setExcelFileError}
                  excelFileError={excelFileError}
                  brandsList={brandsList ? brandsList : []}
                  categoryList={categoryList ? categoryList : []}
                  inverterTypesList={inverterTypesList ? inverterTypesList : []}
                  setFileDetailsList={setFileDetailsList}
                  fileDetailsList={fileDetailsList}
                ></ProductBulkUploadInput>
                <div>
                  <XLSSvg />

                  <p> Drag and drop or browse your files</p>
                </div>
              </div>
            </div>
            {excelFileError && (
              <Label basic color="red">
                {excelFileError}
              </Label>
            )}
            {/* <a href=""><div className={styles.sterlinks}>Download sample file</div></a> */}
            <div style={{ marginBottom: "20px" }}>
              <CSVLink
                filename={"ProductTemplate.csv"}
                data={csvData}
                className={styles.sterlinks}
              >
                Download sample file
              </CSVLink>
            </div>
            <div style={{ marginBottom: "20px" }}>
              <CSVLink
                filename={"Helper.csv"}
                data={helperData}
                className={styles.sterlinks}
              >
                Download Helper file for Category, Brand and Inverter Types
                options
              </CSVLink>
            </div>
            {/* ; // or */}
            {/* <CSVDownload data={csvData} target="_blank" />; */}
            {fileDetailsList.length > 0
              ? fileDetailsList.map((fileDetails, index) => {
                  return (
                    <div className={styles.excelListItem} key={index}>
                      <ExcelSvg />
                      <div className={styles.progress}>
                        <div style={{ marginTop: "1px" }}>
                          <Box className={styles.progressBox}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "start",
                                paddingRight: "5%",
                                fontSize: "10px",
                                fontWeight: "thin",
                                color: "#828282",
                                fontFamily: "Montserrat",
                              }}
                            >
                              {fileDetails.name}
                            </div>
                            <BorderLinearProgress
                              variant="determinate"
                              value={100}
                              valueBuffer={95}
                            />
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                paddingRight: "5%",
                                fontSize: "10px",
                                fontWeight: "thin",
                                color: "#828282",
                                fontFamily: "Montserrat",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "10px",
                                  fontWeight: "thin",
                                  color: "#828282",
                                  fontFamily: "Montserrat",
                                }}
                              >
                                {getUnits(fileDetails.size).value}{" "}
                                {getUnits(fileDetails.size).unit}
                              </div>
                              <div
                                style={{
                                  fontSize: "10px",
                                  fontWeight: "thin",
                                  color: "#828282",
                                  fontFamily: "Montserrat",
                                }}
                              >
                                100%
                              </div>
                            </div>
                          </Box>
                        </div>
                        <div
                          onClick={() => clearForm()}
                          style={{ cursor: "pointer" }}
                        >
                          X
                        </div>
                      </div>
                    </div>
                  );
                })
              : null}
            <div className={styles.twoButton}>
              <Button
                positive
                className={styles.modalactivate}
                onClick={() => saveMultiForm()}
                disabled={buklInputField.length === 0}
              >
                <div className={styles.button}>
                  <span>Upload</span>
                </div>
              </Button>
            </div>
          </div>
        </Modal>
      )}
      <div className={styles.back}>
        <BackArrowSvg onClick={() => navigate("/vendor/products")} />
        <span>Go back</span>
      </div>
      <div className={styles.header}>
        New Product
        <div className={styles.searchAndFilter}>
          <Button
            positive
            className={styles.bulkProduct}
            onClick={() => setModal("bulkupload")}
          >
            <div className={styles.positive}>
              <span>Bulk Product Upload </span>
              {/* <PlusCircle /> */}
            </div>
          </Button>
        </div>
      </div>
      <Formik
        initialValues={inputField}
        enableReinitialize
        onSubmit={saveForm}
        validationSchema={vendorSchema.product}
      >
        {({
          dirty,
          errors,
          getFieldProps,
          handleSubmit,
          values,
          setFieldValue,
          isValid,
          isSubmitting,
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <div className={styles.form}>
                <div className={styles.column1}>
                  <div className={styles.lone}>
                    <InputTemp
                      inputType="text"
                      label={"Product name"}
                      mode="required"
                      placeholder={"Enter Product Name"}
                      marginRight
                      {...getFieldProps("productName")}
                    />
                    <ErrorMessage
                      name={"productName"}
                      render={(error) => (
                        <Label basic color="red" content={error} />
                      )}
                    />
                  </div>
                  <div className={styles.flexForm}>
                    <div className={styles.marginRight}>
                      <SelectTemp
                        inputType="text"
                        label="Category"
                        mode="required"
                        placeholder={"Select Category"}
                        options={
                          categoryList !== null
                            ? [...categoryList]
                                .sort(function (x, y) {
                                  let a = x.category.toUpperCase(),
                                    b = y.category.toUpperCase();
                                  return a === b ? 0 : a > b ? 1 : -1;
                                })
                                .map((category, index) => ({
                                  key: String(index),
                                  label: category.category,
                                  value: category.categoryId,
                                }))
                            : []
                        }
                        onValueChange={(e: any) => {
                          setFieldValue("categoryId", e.value);
                          setFieldValue(
                            "category",
                            categoryList &&
                              categoryList.filter((cat) => {
                                return cat.categoryId === e.value;
                              })[0].category
                          );
                          if (
                            categoryList &&
                            categoryList.filter((cat) => {
                              return cat.categoryId === e.value;
                            })[0].category !== "Inverters"
                          ) {
                            setFieldValue("batType", "");
                            setFieldValue("minIvtCap", 0);
                            setFieldValue("batTypeValue", 0);
                          }
                        }}
                        name="categoryId"
                      />
                      <ErrorMessage
                        name={"categoryId"}
                        render={(error) => (
                          <Label basic color="red" content={error} />
                        )}
                      />
                    </div>
                    <div className={styles.marginLeft}>
                      <SelectTemp
                        inputType="text"
                        label="Brand"
                        placeholder={"Select Brand"}
                        options={
                          brandsList !== null
                            ? [...brandsList]
                                .sort(function (x, y) {
                                  let a = x.brandName.toUpperCase(),
                                    b = y.brandName.toUpperCase();
                                  return a === b ? 0 : a > b ? 1 : -1;
                                })
                                .map((brand, index) => ({
                                  key: String(index),
                                  label: brand.brandName,
                                  value: brand.brandId,
                                }))
                            : []
                        }
                        // value={values.brandId}
                        onValueChange={(e: any) => {
                          setFieldValue("brandId", e.value);
                        }}
                        name="brandId"
                        // {...getFieldProps("categoryId")}
                      />
                      {/* <ErrorMessage
                        name={"brandId"}
                        render={(error) => (
                          <Label basic color="red" content={error} />
                        )}
                      /> */}
                    </div>
                  </div>
                  {categoryList &&
                    categoryList.length > 0 &&
                    categoryList.findIndex((category) => {
                      return (
                        category.category === "Inverters" &&
                        values.categoryId === category.categoryId
                      );
                    }) !== -1 && (
                      <div>
                        <div className={styles.marginRightsm}>
                          <SelectTemp
                            inputType="text"
                            label="Inverter Type"
                            placeholder={"Select Type"}
                            options={
                              inverterTypesList !== null
                                ? [...inverterTypesList]
                                    .sort(function (x, y) {
                                      let a = x.batteryInvtName.toUpperCase(),
                                        b = y.batteryInvtName.toUpperCase();
                                      return a === b ? 0 : a > b ? 1 : -1;
                                    })
                                    .map((brand, index) => ({
                                      key: String(index),
                                      label: brand.batteryInvtName,
                                      value: brand.batteryInvtId,
                                    }))
                                : []
                            }
                            // value={values.brandId}
                            onValueChange={(e: any) => {
                              setFieldValue("batType", e.value);
                            }}
                            name="batType"
                            // {...getFieldProps("categoryId")}
                          />
                          <ErrorMessage
                            name={"batType"}
                            render={(error) => (
                              <Label basic color="red" content={error} />
                            )}
                          />
                        </div>
                        <div className={styles.flexForm}>
                          <div
                            className={`${styles.marginLeftsm} ${styles.marginRightsm}`}
                          >
                            <InputTemp
                              inputType="number"
                              label={"Minimum Inverter Capacity"}
                              placeholder={"Enter Capacity"}
                              marginRight
                              {...getFieldProps("minIvtCap")}
                            />
                            <ErrorMessage
                              name={"minIvtCap"}
                              render={(error) => (
                                <Label basic color="red" content={error} />
                              )}
                            />
                          </div>
                          <div className={styles.marginLeftsm}>
                            <InputTemp
                              inputType="number"
                              label={"Battery Type Value"}
                              mode="required"
                              placeholder={"Enter Type"}
                              marginRight
                              {...getFieldProps("batTypeValue")}
                            />
                            <ErrorMessage
                              name={"batTypeValue"}
                              render={(error) => (
                                <Label basic color="red" content={error} />
                              )}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  <div className={styles.textarea}>
                    <label htmlFor="">
                      Product Description <span className="required">*</span>
                    </label>
                    <MyTextArea
                      rows={3}
                      placeholder="..."
                      name="longDescription"
                      // {...getFieldProps("longDescription")}
                    />
                  </div>

                  <div className={styles.flexForm}>
                    <div className={styles.marginRight}>
                      <InputTemp
                        // inputType="number"
                        label={"Product Current Price"}
                        mode="required"
                        placeholder={"Enter Current Price"}
                        marginRight
                        {...getFieldProps("productCurrentPrice")}
                        inputType={"text"}
                        onChange={(e) =>
                          handleStateChange2(
                            setFieldValue,
                            "productCurrentPrice",
                            e
                          )
                        }
                        onBlur={(e) => handleStateDecimalToPrice(
                          setFieldValue,
                            "productCurrentPrice",
                            e)
                        }
                      />
                      <ErrorMessage
                        name={"productCurrentPrice"}
                        render={(error) => (
                          <Label basic color="red" content={error} />
                        )}
                      />
                    </div>
                    <div
                      className={`${styles.marginLeft} ${styles.marginRight}`}
                    >
                      <InputTemp
                        // inputType="number"
                        label={"Product Previous Price"}
                        placeholder={"Enter Previous Price"}
                        // marginRight
                        {...getFieldProps("productPreviousPrice")}
                        inputType={"text"}
                        
                        onChange={(e) =>
                          handleStateChange2(
                            setFieldValue,
                            "productPreviousPrice",
                            e
                          )
                        }
                        onBlur={(e) => handleStateDecimalToPrice(
                          setFieldValue,
                            "productPreviousPrice",
                            e)
                        }
                      />
                      <ErrorMessage
                        name={"productPreviousPrice"}
                        render={(error) => (
                          <Label basic color="red" content={error} />
                        )}
                      />
                    </div>
                    <div className={styles.marginLeft}>
                      <InputTemp
                        // inputType="number"
                        label={"Product Quantity"}
                        mode="required"
                        placeholder={"Enter Quantity"}
                        marginRight
                        {...getFieldProps("productQuantity")}
                        inputType={"text"}
                        onChange={(e) =>
                          handleStateChange2(
                            setFieldValue,
                            "productQuantity",
                            e
                          )
                        }
                      />
                      <ErrorMessage
                        name={"productQuantity"}
                        render={(error) => (
                          <Label basic color="red" content={error} />
                        )}
                      />
                    </div>
                  </div>
                  <div className={styles.flexStart}>
                    <FormControlLabel
                      // disabled
                      control={<Checkbox />}
                      label="Apply VAT on Product"
                      style={{ padding: 0, marginRight: 50 }}
                      onClick={(e) => {
                        setFieldValue("applyVat", !vat);
                        setVat(!vat);
                      }}
                    />
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                    >
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginRight: "20px",
                        }}
                      >
                        <label>Warranty</label>
                      </span>
                      <FormControlLabel
                        value="yes"
                        control={<Radio />}
                        label="Yes"
                        onClick={() => setFieldValue("isWarranty", true)}
                      />
                      <FormControlLabel
                        value="no"
                        control={<Radio />}
                        label="No"
                        onClick={() => setFieldValue("isWarranty", false)}
                      />
                    </RadioGroup>
                  </div>
                </div>
                <hr className={styles.hr} />
                <div className={styles.column2}>
                  <label htmlFor="upload" className={styles.uploadlabel}>
                    Upload Pictures <span className="required">*</span>{" "}
                  </label>
                  <div className={styles.flexStart}>
                    {imageUpload.length > 0 &&
                      imageUpload.map((image, index) => {
                        return (
                          <div key={index}>
                            <UploadImageTemp
                              src={`${image}`}
                              onChange={(e) => imageHandler(e, index)}
                              btnText="Add Company Logo"
                              accept="image/*"
                            />
                          </div>
                        );
                      })}
                    {imageUpload.length < 5 && (
                      <div>
                        <UploadImageTemp
                          src={""}
                          onChange={(e) => imageHandler(e)}
                          btnText="Add Company Logo"
                          accept="image/*"
                        />
                      </div>
                    )}
                  </div>
                  <div className={styles.textarea2}>
                    <label htmlFor="">
                      Buyer’s Note (input in bullet points){" "}
                      <span className="required">*</span>{" "}
                    </label>
                    <MyTextArea
                      rows={3}
                      placeholder="Add your note"
                      // name="bio"
                      {...getFieldProps("buyerNote")}
                    />
                  </div>
                  <div className={styles.deliveryradio}>
                    <FormLabel id="demo-controlled-radio-buttons-group">
                      Would you like to carry out the delivery of this product?
                      <span className="required">*</span>
                    </FormLabel>

                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                    >
                      <FormControlLabel
                        value="true"
                        control={<Radio />}
                        label="Yes"
                        onClick={() =>
                          setFieldValue("isDeliveryCarryOut", true)
                        }
                      />
                      <FormControlLabel
                        value="false"
                        control={<Radio />}
                        label="No"
                        onClick={() =>
                          setFieldValue("isDeliveryCarryOut", false)
                        }
                      />
                    </RadioGroup>
                  </div>
                  <div className={styles.marginRight}>
                    <InputTemp
                      // inputType="number"
                      label={"Shipping Weight(Kg)"}
                      mode="required"
                      placeholder={"Enter Weight"}
                      marginRight
                      {...getFieldProps("weight")}
                      inputType={"text"}
                      onChange={(e) =>
                        handleStateChange(setFieldValue, "weight", e)
                      }
                    />
                    <ErrorMessage
                      name={"weight"}
                      render={(error) => (
                        <Label basic color="red" content={error} />
                      )}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.footer}>
                <div className={styles.searchAndFilter}>
                  <Button
                    positive
                    className={styles.bulkProduct}
                    type="submit"
                    disabled={!dirty || !isValid || imageUpload.length === 0}
                    // onClick={() => navigate("/vendor/new-product")}
                  >
                    <div className={styles.positive}>
                      <span>Publish Product</span>
                      {/* <PlusCircle /> */}
                    </div>
                  </Button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default observer(NewProduct);
